import type { ReactNode } from 'react';

export function Panel({
  title,
  description,
  actions,
  testId,
  children,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  testId?: string;
  children: ReactNode;
}): ReactNode {
  return (
    <section
      data-testid={testId}
      className="rounded-xl border border-steel-200 bg-white p-5 shadow-sm"
    >
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-steel-100 pb-3">
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-navy-900">{title}</h3>
          {description && <p className="mt-0.5 text-xs text-steel-500">{description}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {children}
    </section>
  );
}

export function SubHeading({ title, note }: { title: string; note?: ReactNode }): ReactNode {
  return (
    <div className="mb-2">
      <h4 className="text-sm font-semibold text-navy-800">{title}</h4>
      {note && <p className="text-xs text-steel-500">{note}</p>}
    </div>
  );
}
